import marketingAndAnalyticsService from '../../services/marketingAndAnalytics/marketingAndAnalyticsService';
import { setInitialRecaptcha } from '../../services/captchaService.js';
import { postFormData } from '../../common/httpService';

const buttons = document.querySelectorAll('.js-button-wait');
console.log('buttons', buttons);
if (buttons.length > 0) {
  Array.prototype.forEach.call(buttons, (buttonWait) => {
    buttonWait.onclick = (e) => {
      e.currentTarget.classList.add('button--wait');
    };
  });
}

const _sendRegisterEventForAnalytics = () => {
  const newsletterCheckbox = document.getElementById('Newsletter');
  if (newsletterCheckbox && newsletterCheckbox.checked) {
    const email = document.getElementById('Email');
    if (email) {
      return marketingAndAnalyticsService.sendRegistration({
        url: window.location.href,
        email: email.value,
      });
    }
    return Promise.resolve();
  }
  return Promise.resolve();
};
const postRegisterRequest = async ({
  postFormData,
  registerData,
  stopRetry,
}) => {
  const response = await postFormData({
    url: 'Account/Register',
    body: registerData,
  });
  let stop = stopRetry === undefined ? false : stopRetry;
  if (response.status !== 200 && postFormData !== undefined && !stop) {
    return postRegisterRequest({
      postFormData,
      registerData,
      stopRetry: true,
    });
  }
  if (response.status !== 200) {
    throw new Error(response.message);
  }
  return response.json();
};

const submitRegister = document.getElementById('submitRegister');
if (submitRegister !== null) {
  submitRegister.addEventListener('click', function (event) {
    event.preventDefault();
    setInitialRecaptcha(window.recaptchaSiteKey).then(async (token) => {
      var placeholderForRecaptcha =
        document.getElementById('recaptchaRegister');

      placeholderForRecaptcha.value = token;
      try {
        const formId = document.getElementById('registerForm');
        if (formId) {
          const registerData = new FormData(formId);
          const response = await postRegisterRequest({
            postFormData,
            registerData,
          });
          if (response.isSuccess === true) {
            _sendRegisterEventForAnalytics().then(() => {
              window.location.href = window.location.origin + response.url;
            });
          } else {
            const validationSummary = document.querySelector(
              '.validation-summary',
            );
            if (validationSummary) {
              let errors = '';
              for (let i = 0; i < response.message.length; i++) {
                errors += `<li style="color:red;">${response.message[i]}</li>`;
              }

              validationSummary.children[0].innerHTML = errors;
            } else {
              throw new Error('Validation errors');
            }
          }
        } else {
          console.error('registerForm id not found');
        }
      } catch (error) {
        console.error(`Error in form `, error);
        alert(
          'Oh no :( something went wrong. Please contact customer support.',
        );
      }
      const buttonsWait = document.getElementsByClassName('js-button-wait');
      for (let index = 0; index < buttonsWait.length; index++) {
        const buttonWait = buttonsWait[index];
        buttonWait.classList.remove('button--wait');
      }
    });
  });
}
